<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { resolveDividerStyling } from './_utils/resolveDividerStyling';
    import DividerView from './Divider.View.svelte';

    import type { DividerContent } from '$lib/types/Components/Divider/DividerContent';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let theme: Theme;
    export let content: DividerContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
    export let id: string;

    const styling = resolveDividerStyling({
        customColor: content.color ?? '',
        lineStyle: content.lineStyle,
        theme,
    });
</script>

<DividerView
    {id}
    box={content.box}
    lineStyle={styling.lineStyle}
    size={content.size}
    color={styling.color}
    borderWidthClass={styling.borderWidthClass}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
